<template>
  <div class="YongLi">
    <!-- 夏季：6-8月 -->
    <div class="summer" v-if="nowMoth >= 6 && nowMoth <= 8">
      <div class="banner">
        <img width="100%" src="../../../assets/img/YongLi/summer_banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/YongLi/summer_liziPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/YongLi/summer_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              脆红李：永利乡土壤肥沃，天气适宜，是种植脆红李的最佳位置，这里种植的脆红李口感好，皮脆而不涩，且果肉含有多种维生素和氨基酸，而且生态无公害。
            </p>
            <p>
              莲花白：永利乡土地肥沃、气候湿润，是种植高山莲花白的最佳位置，这里种植的莲花白品质优良，而且生态无公害，一直以来深受各地客商的亲睐。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/YongLi/summer_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/YongLi/summer_square.png')" color="#B5332B"
        borderBottomColor="#B5332B" boxBorderColor="#DFD1D0" btnBJcolor="#D48D87" hoverBJcolor="#B02118">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/YongLi/summer_square.png')" color="#B5332B"
        borderBottomColor="#B5332B"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/YongLi/summer_square.png')" color="#B5332B"
        borderBottomColor="#B5332B" boxBorderColor="#DFD1D0"></ztxzList>
    </div>
    <!-- 秋季：9-11月 -->
    <div class="autumn" v-else-if="nowMoth >= 9 && nowMoth <= 11">
      <div class="banner">
        <img width="100%" src="../../../assets/img/YongLi/autumn_banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/YongLi/autumn_hetaoPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/YongLi/autumn_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              核桃：核桃营养丰富，适合各种体质的人群食用。它的食用方法也有很多种除了生吃核桃仁之外，也可煮食、炒食、蜜炙、油炸等。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/YongLi/autumn_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/YongLi/autumn_square.png')" color="#82422F"
        borderBottomColor="#82422F" boxBorderColor="#DFD6D4" btnBJcolor="#BF9E95" hoverBJcolor="#844533">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/YongLi/autumn_square.png')" color="#82422F"
        borderBottomColor="#82422F"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/YongLi/autumn_square.png')" color="#82422F"
        borderBottomColor="#82422F" boxBorderColor="#DFD6D4"></ztxzList>
    </div>
    <!-- 冬季：1、2、12月 -->
    <div class="winter" v-else-if="(nowMoth >= 1 && nowMoth <= 2) || nowMoth==12">
      <div class="banner">
        <img width="100%" src="../../../assets/img/YongLi/winter_banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/YongLi/winter_pingguoPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/YongLi/winter_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              高山独特的无公害有机苹果具有良好的果形，亮丽的果色，外形硕大，口感松，水分充足，糖分高，一直以来深受各地客商的亲睐。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/YongLi/winter_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/YongLi/winter_square.png')" color="#9C0014"
        borderBottomColor="#9C0014" boxBorderColor="#D9A1A8" btnBJcolor="#CC7F89" hoverBJcolor="#A00318">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/YongLi/winter_square.png')" color="#9C0014"
        borderBottomColor="#9C0014"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/YongLi/winter_square.png')" color="#9C0014"
        borderBottomColor="#9C0014" boxBorderColor="#D9A1A8"></ztxzList>
    </div>
    <!--四季-->
    <div class="spring" v-else>
      <div class="banner">
        <img width="100%" src="../../../assets/img/YongLi/banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/YongLi/rouPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/YongLi/square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              腊肉：腊肉外黑油亮，耐贮存。经清洗煮、蒸、炒后可食用，肉质红亮、肥而不腻、味香醇美。为当地待客和馈赠宾朋的土特产品，畅销外地。由永利产高山新鲜猪肉用盐腌制后，挂在火炉上方，让燃烧的柏树和香樟树枝的烟熏烤后风干而成。
            </p>
            <p>
              跑山羊：随着生态农产品越来越受市场欢迎，永利乡距离县城约80公里，山间长满了翠色欲流的青草，具有得天独厚的自然生态环境。当地村民借助山区林草丰富的资源优势，养起了“跑山羊”，吃起了生态饭。
            </p>
            <p>
              黄牛肉：永利乡家家都有养殖黄牛，其养殖简单，只要以大自然青草为主食，农家种植的芍藤、稻谷杆为辅，一般黄牛3-5年便可成形。正宗黄牛吸收天然灵气，善于运动，所以黄牛肉肉质滑嫩，营养价值高，经常出现在餐桌上，吃起来还有一点点嚼劲。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/YongLi/jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/YongLi/square.png')" color="#AE1C13"
        borderBottomColor="#AE1C13" boxBorderColor="#E3D6D5" btnBJcolor="#D48D87" hoverBJcolor="#AF2118">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/YongLi/square.png')" color="#AE1C13"
        borderBottomColor="#AE1C13"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/YongLi/square.png')" color="#AE1C13"
        borderBottomColor="#AE1C13" boxBorderColor="#E3D6D5"></ztxzList>
    </div>    
  </div>
</template>
<script>
import ztxzList from "@/components/ztxzList/index";
import ConvenientService from "@/components/ConvenientService/index";
import GovernmentServices from "@/components/GovernmentServices/index";
import { getServerDate, matterQuery } from "@/api/map/index"
import { mixin } from "../../../mixin";
export default {
  name: 'YongLi',
  components: { ztxzList, ConvenientService,GovernmentServices },
  data() {
    return {
      nowMoth: null, //当前月份
      mapId: this.$route.params.mapId || null,  //点位ID
      matterList: [],  //事项列表
      villages: [],  //乡镇列表
      name:'永利彝族乡'
    };
  },
  mixins:[mixin],
  created() {
    this.$emit('public_header', false);

  },
  // mounted() {
  //   // if (this.$route.params.mapId) {
  //   //   sessionStorage.setItem('mapId', this.mapId)
  //   // }
  //   // if (sessionStorage.getItem('mapId')) {
  //   //   this.mapId = sessionStorage.getItem('mapId');
  //   // }
  //   this.getData()
  //   this.getMatterList()
  // },

  // methods: {
  //   // 获取服务器当前时间
  //   getData() {
  //     getServerDate().then(res => {
  //       // console.log(res,'时间')
  //       if (res.data.code == 200) {
  //         this.FormatData(res.data.data)
  //       }
  //     })
  //   },
  //   // 获取便民办事
  //   getMatterList() {
  //     let query = {
  //       id: this.mapId
  //     }
  //     matterQuery(query).then(res => {
  //       // console.log(res,'事项列表')
  //       if (res.data.code == 200) {
  //         if (res.data.rows && res.data.rows.length > 0) {
  //           this.matterList = res.data.rows.slice(0, 5);
  //         } else {
  //           // this.$message.error('暂无事项！')
  //           console.log('暂无事项')
  //         }
  //       } else {
  //         this.$message.error('事项列表获取失败！')
  //       }
  //     })
  //   },
  //   // 日期时间格式化
  //   // 日期时间格式化
  //   FormatData(n) {
  //     // console.log(n, '时间')
  //     let now = new Date(n),
  //       // y = now.getFullYear();
  //       m = now.getMonth() + 1;
  //     // d = now.getDate();
  //     // return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
  //     this.nowMoth = m;
  //   },
  // },
};
</script>
<style scoped>
.YongLi {
  background: url('../../../../src/assets/img/YongLi/bg.png');
  background-size: 100% 100%;
}

.banner {
  width: 100%;
}

.con1 {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.con1 .con1_leftBox,
.con1 .con1_rightBox {
  width: 49%;
}

.con1 .con1_rightBox .cont {
  text-align: left;
  text-indent: 2em;
  margin: 10px 0;
  height: 83%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.spring .top_title {
  color: #AE1C13;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #AE1C13;
  height: 12%;
}

.summer .top_title {
  color: #B5332B;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #B5332B;
  height: 12%;
}

.autumn .top_title {
  color: #82422F;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #82422F;
  height: 12%;
}

.winter .top_title {
  color: #9C0014;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #9C0014;
  height: 12%;
}

.con2 {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.list_item {
  background-color: #F9F9F9;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 78px;
  padding: 0 10px;
  border: 1px solid #EBA970;
  margin-bottom: 20px;
}

.list_item_left {
  font-size: 18px;
  font-weight: bold;
}

.banshi_btn {
  background-color: rgb(234, 182, 134);
  color: rgb(255, 255, 255);
  border: none;
  font-size: 18px;
  font-weight: bold;
  border-radius: 7px;
}

.banshi_btn:hover {
  background-color: #DB7312;
}

.ztxz {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.xzlist {
  margin: 20px 0;
  background-color: #F9F9F9;
  border: 1px solid #EBA970;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}

.xzlist a {
  display: inline-block;
  margin-right: 40px;
  font-size: 16px;
  font-weight: 550;
}</style>